import { Grid, Step, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { StyledStepLabel, StyledStepper } from "shared/styled/General"
import { StyledGrid } from "./CustomerStepper.styled"

const StepIcon = (props) => {
  const { active, completed } = props

  return active ? null : completed ? null : null
}

export const CustomerStepper = (props) => {
  const { content, steps, children, activeStep } = props
  const { t } = useTranslation("translation", { keyPrefix: "settings.wizard" })

  return (
    <StyledGrid container direction="column" pb={4}>
      <Grid item>
        <Typography variant="h1">{t(`header.step${activeStep + 1}`)}</Typography>
      </Grid>
      <Grid item>
        <StyledStepper connector={false} activeStep={activeStep} orientation="horizontal">
          {steps.map((data, index) => (
            <Step key={index}>
              <StyledStepLabel StepIconComponent={StepIcon}>
                {index + 1}. {t(`title.step${index + 1}`, data.fallbackTitle)}
              </StyledStepLabel>
            </Step>
          ))}
        </StyledStepper>
      </Grid>

      <Grid container>
        <Grid item>{content && content(activeStep)}</Grid>
        <Grid item md={12}>
          {children}
        </Grid>
      </Grid>
    </StyledGrid>
  )
}
